export const FETCH_INFO_REQUEST = 'minhaConta/FETCH_INFO_REQUEST';
export const FETCH_INFO_SUCCESS = 'minhaConta/FETCH_INFO_SUCCESS';
export const ENVIAR_DOCUMENTOS_REQUEST = 'minhaConta/ENVIAR_DOCUMENTOS_REQUEST';
export const ENVIAR_DOCUMENTOS_SUCCESS = 'minhaConta/ENVIAR_DOCUMENTOS_SUCCESS';
